// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"45d68fc9","69":"f55f15f3","239":"558b8238","284":"9a9ee3a0","453":"6452bf19","455":"5f87b275","977":"f1e98e52"}[chunkId] + ".chunk.js";
};